import { Alert } from '@mui/lab'
import { LinearProgress, TextField } from '@mui/material'
import React, { useState } from 'react'
import MainButton from '../common/util/input/MainButton'
import { post_admin } from '../helpers/Api'

export const AddToken = ({ accountName, password }) => {
    const [tokenSymbol, setTokenSymbol] = useState(null)
    const [tokenContract, setTokenContract] = useState(null)
    const [success, setSuccess] = useState(null)
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const changeToken = (e) => {
        setTokenSymbol(e.target.value)
    }

    const changeContract = (e) => {
        setTokenContract(e.target.value)
    }

    const parseResponse = (res) => {
        if (res && res['status'] === 200) {
            setSuccess(true)
            setError(false)
        }
        setIsLoading(false)
    }

    const parseError = () => {
        setSuccess(false)
        setError(true)
        setIsLoading(false)
    }

    const addToken = () => {
        setIsLoading(true)
        post_admin(
            'add-token',
            { symbol: tokenSymbol, contract: tokenContract },
            accountName,
            password,
        )
            .then(parseResponse)
            .catch(parseError)
    }

    return (
        <div
            className={
                'm-4 p-4 border bg-zinc-300 dark:!bg-paper rounded-md shadow-xl h-full border-paperl'
            }
        >
            <div className={'font-bold text-xl'}>Add Drop/Crafting Token</div>
            <div className={'grid grid-cols-3'}>
                <div className={'m-4'}>
                    <TextField
                        size="small"
                        value={tokenSymbol}
                        placeholder={'Token Symbol'}
                        inputProps={{
                            style: {
                                height: '1.2rem',
                                fontSize: '0.7rem',
                            },
                        }}
                        onChange={changeToken}
                        InputProps={{ tabIndex: 1 }}
                        error={
                            !tokenSymbol ||
                            !RegExp('\\d,[A-Z]+').test(tokenSymbol)
                        }
                    />
                </div>
                <div className={'m-4'}>
                    <TextField
                        size="small"
                        value={tokenContract}
                        placeholder={'Token Contract'}
                        inputProps={{
                            style: {
                                height: '1.2rem',
                                fontSize: '0.7rem',
                            },
                        }}
                        onChange={changeContract}
                        InputProps={{ tabIndex: 2 }}
                        error={!tokenContract || tokenContract.length > 12}
                    />
                </div>
                <MainButton className="btn" onClick={addToken} tabIndex={3}>
                    Add
                </MainButton>
            </div>
            {isLoading ? <LinearProgress /> : ''}
            {success ? (
                <Alert severity={'success'} onClose={() => setSuccess(false)}>
                    Token added!
                </Alert>
            ) : (
                ''
            )}
            {error ? (
                <Alert severity={'error'} onClose={() => setError(false)}>
                    Unexpected Error
                </Alert>
            ) : (
                ''
            )}
        </div>
    )
}
